import { mpx } from '@didi/es-mpx-creator'
import { is } from '@didi/webx-js';
// 登录状态值
export const LoginStatus = {
  LOGIN_NONE: 'LOGIN_NONE', // 未登录
  LOGIN_ING: 'LOGIN_ING', // 登录中
  LOGIN_SUC: 'LOGIN_SUC', // 登录成功
  LOGIN_FAIL: 'LOGIN_FAIL', // 登录失败
  LOGOUT: 'LOGOUT' // 登出
}
/**
 * @description: 隐藏弹窗key
 */
export const PRIVACY_KEY = 'IS_SIGN_PRIVACY'



export const LOAD_FAIL_CONTENT = "请检查网络设置或稍后重试"
// 手机校验正则
export const MOBILE_CHECK_REG = new RegExp('^[1][3,4,5,6,7,8,9][0-9]{9}$')
// 邮箱校验正则
export const EMAIL_CHECK_REG = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

// 小程序 添加底部安全区域
export const bottomSafeArea = () => {
  if (__mpx_mode__ !== 'web') {
    return '16px'
  } else {
    return '0px'
  }
}

// 费用明细tips文案
export const FEE_DETAIL_TIPS = {
  '1,0': '暂收下铺价，占座成功后退回差额',
  '0,1': '不支持学生优惠',
  '1,1': '暂收下铺价，占座成功后退回差额（不支持学生优惠）',
}

export const DIDI_REQUEST = (
  requestUrl,
  data,
  onSuccess = () => { },
  onFail = () => { }
) => {
  return mpx.$http
    .post(requestUrl, { data })
    .then(({ data, success, code, message }) => {
      if (success) {
        onSuccess({ data, code, message })
      } else {
        onFail()
        mpx.showToast({
          title: LOAD_FAIL_CONTENT, //提示的内容,
          icon: 'error' //图标,
        })
      }
    })
    .catch(e => {
      console.log('error', e)
      onFail()
    })
}

export const isDdPassengerH5 = __mpx_mode__ === 'web' && is('passenger');
//滴滴出行微信小程序
export const isWXMini = __mpx_mode__ === 'web' && is('weixin.miniprogram');
//滴滴出行支付宝小程序
export const isALIMini = __mpx_mode__ === 'web' && is('alipay.miniprogram');

/**
 * @description:订单来源
 *  1-C端H5
    2-C端微信小程序
    3-C端支付宝小程序
    120-其他
 */
export const ORDER_SOURCE = isDdPassengerH5 ? '1' : isWXMini ? '2' : isALIMini ? '3' : '120'

// 订单状态配置
export const ORDERSTATUSINFO = {
  prepay: {
    title: '支付成功',
    status: '支付成功，等待出票',
    desc: '占座成功后会立即出票并发送出票成功短信'
  },
  payed: {
    title: '支付成功',
    status: '下单成功，等待出票',
    desc: '出票成功后滴滴会立即短信通知您'
  },
  modify: {
    title: '改签详情',
    status: '改签申请提交成功',
    desc: ''
  },
  refund: {
    title: '退票申请',
    status: '退票申请提交成功',
    desc: ''
  }
}

// 卧铺坐席类型
// "3": "硬卧",
// "4": "软卧",
// "5": "包厢硬卧",
// "6": "高级软卧",
// "A": "高级动卧",
// "C": "混编硬卧",
// "F": "动卧",
// "G": "二人软包",
// "H": "一人软包",
// "I": "一等卧",
// "J": "二等卧",
// "L": "混编软卧",
export const SLEEPER_SEAT_TYPE = ['3', '4', '5', '6', 'A', 'C', 'F', 'G', 'H', 'I', 'J', 'L']
// 普通坐席类型
// "1": "硬座",
// "2": "软座",
// "7": "一等软座",
// "8": "二等软座",
// "9": "商务座",
// "B": "混编硬座",
// "D": "包厢软座",
// "E": "特等软座",
// "K": "混编软座",
// "M": "一等座",
// "O": "二等座",
// "P": "特等座",
// "Q": "多功能座",
// "S": "二等包座",
// "D1": "硬卧代硬座"
export const COMMON_SEAT_TYPE = ['1', '2', '7', '8', '9', 'B', 'D', 'E', 'K', 'M', 'O', 'P', 'Q', 'S', 'D1']
// 所有坐席类型
export const SEAT_TYPE = [
  ...COMMON_SEAT_TYPE,
  ...SLEEPER_SEAT_TYPE
]

export const RightsTypeMap = {
  normal: 3, // 12306线上票
  offline: 1, // 便捷购票
  worryfree: 2 // 退改无忧
}


export const WORRY_FREE_RIGHT_POPINFO_DATA = {
  pop_title: 'https://ut-static.udache.com/webx/sfc/-M6buh18AuAVB24r9LzKr.png',
  pop_sub_title: '畅享8大专属权益，最高价值328元',
  image_list: [
    'https://ut-static.udache.com/webx/sfc/1nTSc8zrtivJXZKPmh3Do.png',
    'https://ut-static.udache.com/webx/sfc/2Daah7QEWSVcM_ydkjd-i.png',
    'https://ut-static.udache.com/webx/sfc/th-J145UCdZWayrr6uMaa.png',
    'https://ut-static.udache.com/webx/sfc/38IKBGFkdkAbazDUTrF2G.png',
    'https://ut-static.udache.com/webx/sfc/1IsXWt6m2MfDotmfy0ufF.png',
    'https://ut-static.udache.com/webx/sfc/nrLN0gwb2Hgn5DO3v5PBO.png',
    'https://ut-static.udache.com/webx/sfc/K9Gk73ssGaViO8fWlSpYs.png',
    'https://ut-static.udache.com/webx/sfc/nHwtwXdjMaUoh_dahkJ10.png'
  ],
  text_list: [
    '1、购买退改无忧服务的用户，如在发车时间前因退票或改签产生了手续费，系统会按一定比例为您补偿手续费，暂不支持港铁理赔；\n2、系统会补偿1次退票或改签产生手续费的场景，如订单改签时未产生改签手续费，后续若办理退票并产生手续费时，依然可享受手续费补偿；\n3、补偿的款项会直接在线补偿，随退票款或改签退款一同退回原支付账户；\n4、退改手续费补偿规则：仅支持滴滴线上退票或改签补偿，提交退票时，距离发车时间48小时以上，补偿100%手续费；距离发车24-48小时内，补偿70%手续费；距离发车24小时内，补偿50%手续费，最高补偿100元。提交改签时，开车前48小时内改签至发车前列车或开车前24-48小时内改签至发车日期后的列车，补偿100%手续费，开车前24小时内，改签至发车日期后的列车，补偿50%手续费；最高赔付100元，其他场景不补偿；\n5、出票成功后，退改无忧权益立刻生效，不支持退款；若出票失败全额自动退还至原支付账户。',
    '1、免登录12306账号购票；\n2、全天24小时快速出票；\n3、24小时专人客服服务；',
    '1、赠2张7.5折滴滴接送站打车券，最高优惠30元，满20元可用，支持特快、特惠、优享、快车、专车，有效期7天； \n2、限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。',
    '1、赠价值最高100元的滴滴租车满减券，有效期3天；\n2、阶梯立减规则：满200元减20元；满300元减50元；满600元减60元；满1000元减100元。\n3、限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。',
    '1、赠价值30元的青桔电单车6折购卡券，有效期3天。\n2、限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。',
    '1、赠价值5元的青桔单车5折畅骑卡折扣券，有效期3天；\n2、限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。',
    '1、赠价值3元滴滴拼车券，满10元可用，有效期3天；\n2、限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。',
    '1、赠10个抢票加速包，下抢票单时默认使用，有效期3天；\n2、限时赠券，出票成功后自动发放，可在火车票首页-天天领福利-加速包查看。'
  ]
}